var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimboloPregunta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_165926",
    "data-name": "Grupo 165926",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.809,
    height: 33.799,
    viewBox: "0 0 33.809 33.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165082",
    "data-name": "Grupo 165082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97680",
    "data-name": "Trazado 97680",
    d: "M17.571,33.656A16.082,16.082,0,0,1,14.036,1.887a15.963,15.963,0,0,1,10.088,1,1.62,1.62,0,0,1-1.318,2.959,12.84,12.84,0,0,0-16,18.717,12.84,12.84,0,0,0,23.612-6.981V16.249a1.62,1.62,0,1,1,3.239,0v1.33A16.1,16.1,0,0,1,17.571,33.656Z",
    transform: "translate(-0.675 -0.671)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97684",
    "data-name": "Trazado 97684",
    d: "M16.072,32.17A16.084,16.084,0,0,1,3.857,5.637,16.079,16.079,0,0,1,22.624,1.4a1.62,1.62,0,1,1-1.318,2.959,12.84,12.84,0,0,0-16,18.717A12.84,12.84,0,0,0,28.92,16.092V14.762a1.62,1.62,0,0,1,3.239,0v1.33A16.1,16.1,0,0,1,16.072,32.17Z",
    transform: "translate(33.809 1.684) rotate(93)",
    fill: "red"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98415",
    "data-name": "Trazado 98415",
    d: "M7.65,18.375A1.621,1.621,0,0,0,9.35,16.7a1.6,1.6,0,0,0-1.7-1.625A1.589,1.589,0,0,0,5.975,16.7,1.615,1.615,0,0,0,7.65,18.375ZM8.975,13.2a3.7,3.7,0,0,1,2-3.675C12.725,8.4,14.05,7.3,14.05,5c0-3.1-2.65-5.325-6.075-5.325A6.352,6.352,0,0,0,1.425,5.4l2.75.525A3.873,3.873,0,0,1,7.9,2.175a3.011,3.011,0,0,1,3.175,2.95c0,1.35-1.05,2.125-2.2,2.925C7.275,9.175,6.35,10.425,6.35,13.2Z",
    transform: "translate(9.225 7.325)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimboloPregunta);
export default __webpack_public_path__ + "static/media/simbolo-pregunta.c6ad367702a04e4016a1e62ef3854df3.svg";
export { ForwardRef as ReactComponent };